import { Toggle } from "@monsterindia/global-ui-components";
import Image from "next/image";
import React, { ReactNode } from "react";

type HeaderContentToggleProps = {
  heading?: string;
  content?: string[];
  showToggle?: boolean;
  name: string;
  isToggleChecked?: boolean;
  children?: ReactNode;
  image?: string;
  showBorder?: boolean;
  imageHeight?: number;
  imageWidth?: number;
  headingStyles?: string;
  setToggleVisibility?: (name: string) => void;
};

function HeaderContentToggle({
  heading,
  content,
  showToggle = false,
  isToggleChecked,
  name,
  image,
  children,
  showBorder = false,
  imageHeight,
  imageWidth,
  headingStyles,
  setToggleVisibility = () => {},
}: HeaderContentToggleProps) {
  const hasHeading = !!heading;
  const hasContent = !!content;

  return (
    <div
      className={`flex items-baseline justify-between rounded-lg ${
        showBorder ? "border-[#d2d1d6] p-3 md:border" : ""
      } `}
    >
      <div>
        {hasHeading && hasContent && (
          <h3 className="mb-2 text-base font-semibold">{heading}</h3>
        )}

        <div className="flex items-center justify-between gap-2">
          {hasHeading && !hasContent && (
            <div className="flex items-center gap-1">
              {image && (
                <Image
                  src={image}
                  alt="image"
                  height={imageHeight}
                  width={imageWidth}
                />
              )}
              {children && !image && <div>{children}</div>}

              <h3
                className={`${
                  headingStyles ? headingStyles : "text-base font-semibold"
                }`}
              >
                {heading}
              </h3>
            </div>
          )}
          {children && hasContent && <div>{children}</div>}

          {hasContent && (
            <div>
              {content?.map((el) => (
                <p className="text-content-secondary text-xs" key={el}>
                  {el}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>

      {showToggle && (
        <Toggle
          size="small"
          checked={isToggleChecked}
          onChange={() => setToggleVisibility(name)}
          value={name}
        />
      )}
    </div>
  );
}

export default HeaderContentToggle;
